import styled from "@emotion/styled";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AddFiltersToPageModal from "./AddFiltersToPageModal";
import {
  getSiteConfiguration,
  initDashBoardLoader,
  updateSiteConfiguration,
} from "../../../../store/actions";

const AddContainer = styled.div(
  ({ theme }) => `
  font-size: 12px;
  margin-left: 5px;
  color: ${theme.menuPrimary ? theme.textOnPrimary : theme.text.secondary};
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`
);

export default function AddFiltersToPage({ activeTab }) {
  const siteConfig = useSelector((state) => state.siteConfiguration);
  const tenantId = useSelector((state) => state.layout.tenantId);

  const dispatch = useDispatch();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!siteConfig.siteName) {
      dispatch(getSiteConfiguration(tenantId));
    }
  }, [dispatch, siteConfig.siteName, tenantId]);

  async function onSave(filters) {
    const res = {
      ...siteConfig,
      menuFilters: {
        ...siteConfig.menuFilters,
        list: filters,
      },
    };

    // do not remove this await
    // 'await' has no effect on the type of this expression. message is not true
    await dispatch(updateSiteConfiguration(res));
    dispatch(initDashBoardLoader(activeTab?.slug));
    setShow(false);
  }

  return (
    <>
      <AddContainer onClick={() => setShow(true)}>
        <FontAwesomeIcon icon={["fas", "plus"]} style={{ marginRight: 5 }} />
        ADD FILTERS
      </AddContainer>

      {show ? (
        <AddFiltersToPageModal
          onClose={() => setShow(false)}
          siteConfig={siteConfig}
          activeTab={activeTab ?? {}}
          onSave={onSave}
        />
      ) : null}
    </>
  );
}
